import type { Shape } from '@rsos/constants/mapTypes';

export interface Extent {
  xmin: number;
  ymin: number;
  xmax: number;
  ymax: number;
}

/**
 * Normalize the shapes coordinates and return maxX, maxY, minX and minY
 * @param {Array|Object} shapes - {bottom_right, top_left} for the map
 */
export const normalizeExtent = (shapes: Shape[]): Extent | undefined => {
  if (!Array.isArray(shapes)) {
    // eslint-disable-next-line no-console
    console.error('expected shapes to be an array in normalizeExtent');
    return undefined;
  } else if (!shapes.length) {
    // default to US
    return {
      xmin: -65.524514,
      ymin: 23.634763,
      xmax: -125.979106,
      ymax: 48.999968,
    };
  } else {
    // x is longitutde, y is latitude
    const maxX = shapes?.[0]?.top_left?.longitude;
    const maxY = shapes?.[0]?.top_left?.latitude;
    const minX = shapes?.[0]?.bottom_right?.longitude;
    const minY = shapes?.[0]?.bottom_right?.latitude;

    return {
      xmin: minX,
      ymin: minY,
      xmax: maxX,
      ymax: maxY,
    };
  }
};
